var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63272 1.13445C9.83068 0.920154 10.1693 0.920154 10.3673 1.13445L18.4744 9.91072C18.7703 10.231 18.5431 10.75 18.1072 10.75H1.89283C1.45686 10.75 1.22973 10.231 1.52555 9.91072L9.63272 1.13445L9.27497 0.803976L9.63272 1.13445Z",
    fill: "var(--Surface-Surface-01, #FFF)",
    stroke: "var(--Stroke-Stroke-02, #D9E0EA)",
    strokeWidth: "1px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleIcon);
export default __webpack_public_path__ + "static/media/triangleIcon.dc8d16a5aebf21868875949058ea5ab5.svg";
export { ForwardRef as ReactComponent };